<div class="modal-header"><h2 class="modal-title">ACH Transaction</h2></div>
<div class="modal-body">
    <dx-form *ngIf="achTransaction" [formData]="achTransaction" validationGroup="mainValidationGroup">
        <dxi-item itemType="group">
            <dxi-item dataField="created" editorType="dxDateBox" [label]="{ text: 'Date' }" [editorOptions]="{ disabled: true }"></dxi-item>
            <dxi-item [label]="{ text: 'Invoice' }">
                <div *dxTemplate>
                    <dx-select-box
                        [(value)]="achTransaction.invoiceId"
                        [items]="invoices"
                        valueExpr="id"
                        displayExpr="invoiceNumber"
                        [disabled]="!canEditAmount"
                        searchEnabled="true"
                        searchMode="startswith"
                    >
                    </dx-select-box>
                </div>
                <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="amount" [label]="{ text: 'Amount' }" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 }, step: 0, disabled: !canEditAmount }">
                <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                <dxi-validation-rule type="numeric" message="Needs to be a number"> </dxi-validation-rule>
                <dxi-validation-rule type="range" min="0.01" message="Cannot be less than 0.01"> </dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="bankConfirmationNumber" [label]="{ text: 'Bank Confirmation #' }"></dxi-item>
            <dxi-item dataField="transferInitiated" editorType="dxDateBox" [label]="{ text: 'Transfer Initiated' }"></dxi-item>
            <dxi-item dataField="transferInitiatedBy" [label]="{ text: 'Transfer Initiated By' }" [editorOptions]="{ disabled: true }"></dxi-item>
            <dxi-item [label]="{ text: 'Notes' }">
                <div *dxTemplate>
                    <dx-text-area [(value)]="achTransaction.notes" [height]="100"> </dx-text-area>
                </div>
            </dxi-item>
        </dxi-item>
    </dx-form>
</div>

<div class="modal-footer">
    <button class="btn btn-success" (click)="save()">Save</button>
    <button class="btn btn-default" (click)="close()">Cancel</button>
</div>
